import React, { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { useMutation } from 'react-query'
import { AlertTitle } from '@material-ui/lab'
import { Link, makeStyles, Typography } from '@material-ui/core'
import NoLayoutContainer from '../../components/layout/NoLayoutContainer/NoLayoutContainer'
import MySnackbar from '../../components/MySnackbar/MySnackbar'
import useHistoryPush from '../../hooks/useHistoryPush'
import confirmEmail from '../../Apis/user/confirmEmail'
import getQueryParameterByName from '../../utils/helpers/getQueryParameterByName'
import localStorageIds from '../../utils/constants/localStorageIds'
import { redirectToApp } from '../../utils/helpers/redirectToApp'
import confirmEmailPageStyles from './confirmEmailPage.styles'

// The confirmation link params stay compatible with getQueryParameterByName on
// purpose: it keeps '+' intact, unlike URLSearchParams, and Identity email
// tokens are Base64.
const CONFIRMATION_LINK_PARAMS = ['email', 'emailToken', 'redirect']

const ConfirmEmailPage = () => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
  const [counter, setCounter] = useState()
  const translate = useTranslate()
  const { redirect } = useHistoryPush()
  const useStyles = makeStyles(confirmEmailPageStyles)
  const classes = useStyles()
  const email = getQueryParameterByName('email')
  const emailToken = getQueryParameterByName('emailToken')
  const redirectUrl = getQueryParameterByName('redirect')

  // Remove token in case user is logged in with another account.
  localStorage.removeItem(localStorageIds.TOKEN)

  const confirmUserEmail = useMutation((data) => confirmEmail(data), {
    onSuccess: () => {
      setIsSnackbarOpen(true)
      if (!!redirectUrl) redirectToApp('mismatchfans', 'confirm')
    },
    onError: () => {
      setCounter(6)
      setIsSnackbarOpen(true)
    },
  })

  useEffect(() => {
    if (email && emailToken) {
      confirmUserEmail.mutate({
        email,
        emailToken,
      })
    } else {
      redirect('/login', null, CONFIRMATION_LINK_PARAMS)
    }
  }, [])

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)

    if (counter === 0) {
      redirect('/send-confirmation-email', [{ initialEmail: email }], CONFIRMATION_LINK_PARAMS)
    }

    return () => clearInterval(timer)
  }, [counter])

  const redirectToLogin = () => redirect('/login', [{ email }], CONFIRMATION_LINK_PARAMS)

  const onCloseSnackbar = () => {
    setIsSnackbarOpen(false)
    if (confirmUserEmail.isSuccess) redirectToLogin()
  }

  return (
    <NoLayoutContainer>
      <div className={classes.wrapper}>
        <Typography variant='h5'>
          {confirmUserEmail.isSuccess
            ? translate('ra.successMessages.confirmEmailSuccess')
            : translate('ra.text.confirmingEmail')}
        </Typography>
        <Link
          component='button'
          variant='body2'
          className={classes.link}
          onClick={redirectToLogin}
        >
          {translate('ra.gridLinks.login')}
        </Link>
      </div>

      <MySnackbar
        isOpen={isSnackbarOpen}
        onClose={onCloseSnackbar}
        isSuccess={confirmUserEmail.isSuccess}
        successMessage={translate('ra.successMessages.confirmEmailSuccess')}
        errorMessage={
          <>
            <AlertTitle>{translate('ra.errorMessages.confirmEmailError')}</AlertTitle>
            {`${translate('ra.errorMessages.confirmEmailErrorRedirect')} `}
            <b>{counter}</b>
          </>
        }
      />
    </NoLayoutContainer>
  )
}

export default ConfirmEmailPage
